import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GraphQLBaseService {

  constructor(
    private apollo: Apollo
  ) { }

  doQuery(graphqlQuery: any, variables?: any) {
    return this.apollo.query({
      query: gql`${graphqlQuery}`,
      variables: variables,
      fetchPolicy:'no-cache'
    })
  }

  doMutate(graphqlMutation: any, variables?: any) {
    return this.apollo.mutate({
      mutation: gql`${graphqlMutation}`,
      variables: variables
    })
  }
}
